import { render, staticRenderFns } from "./technicals.vue?vue&type=template&id=16f82c75&"
import script from "./technicals.vue?vue&type=script&lang=ts&"
export * from "./technicals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports